import { SvgComponentProps, Svg } from './svg-component';

export const CloseIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size ?? 16} height={size ?? 16} viewBox="0 0 16 16" fill="none" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.463 2.251a.857.857 0 0 0-1.212 1.212L6.788 8 2.25 12.537a.857.857 0 0 0 1.212 1.212L8 9.212l4.537 4.537a.857.857 0 0 0 1.212-1.212L9.212 8l4.537-4.537a.857.857 0 0 0-1.212-1.212L8 6.788 3.463 2.25Z"
            fill="currentColor"
        />
    </Svg>
);
